<div class="agpr-aiPromptSuggestions-suggestedPrompts">
    <label
        id="aiPromptSuggestions_list"
        class="agpr-aiPromptSuggestions-suggestedPrompts-label"
    >
        {{'Common.dialog.aiRefinement.suggestedPrompts.label' | localize}}
    </label>
    <ul
        id="suggestions"
        aria-labelledby="aiPromptSuggestions_list"
        agprListKeyboardNavigation
        [focusOnChild]="true"
        class="agpr-aiPromptSuggestions-suggestedPrompts-listContainer"
    >
        <li
            *ngFor="let suggestedPrompt of suggestedPrompts; let suggestedIndex = index"
            class="agpr-aiPromptSuggestions-suggestedPrompts-list"
            [ngClass]="{'agpr-aiPromptSuggestions-suggestedPrompts-list-selected' : selectedPrompt?.includes(suggestedPrompt.prompt)}"
            (mouseenter)="hideMenu()"
        >
            <agpr-button
                class="agpr-aiPromptSuggestions-suggestedPrompts-list-button"
                [ariaHasPopup]="suggestedPrompt && !suggestedPrompt.options ? 'dialog' : false"
                (click)="setPrompt($event, suggestedPrompt)"
            >
                <div class="agpr-aiPromptSuggestions-suggestedPrompts-list-icon">
                    <span
                        aria-hidden="true"
                        class="fa-kit-duotone fa-agpr-ai"
                    ></span>
                </div>
                <div class="agpr-aiPromptSuggestions-suggestedPrompts-list-prompt">
                    {{ suggestedPrompt.prompt | localize }} <span *ngIf="suggestedPrompt?.options">...</span>
                </div>
            </agpr-button>
            <div
                *ngIf="suggestedPrompt?.options"
                class="agpr-aiPromptSuggestions-suggestedPrompts-list-options"
            >
                <!-- I guess can use split-button too, but the popup is a bit off -->
                <agpr-kebab-menu
                    #kebabMenu
                    class="agpr-aiPromptSuggestions-suggestedPrompts-list-optionsButton"
                    [id]="'ai_prompt_suggestions_kebab_menu_' + suggestedIndex"
                    [icon]="'fa-regular fa-regular fa-angle-right'"
                    [ignoreMouseMove]="true"
                    [options]="suggestedPrompt.options"
                    [data]="suggestedPrompt"
                    [loading]="null"
                    [useScrollPanel]="true"
                    tooltip="Common.dialog.aiRefinement.suggestedPrompts.kebabMenuButton"
                    ariaLabel="Common.dialog.aiRefinement.suggestedPrompts.kebabMenuButtonDescription"
                    panelPositionX="right"
                    textAlignment="left"
                    panelClass="agpr-kebabMenu-panel--compactScrollbar"
                ></agpr-kebab-menu>
            </div>
        </li>
    </ul>

</div>
<div class="agpr-aiPromptSuggestions-horizontalLine"></div>
<agpr-text-input
    [id]="'ai_refinement_prompt'"
    [label]="'Common.dialog.aiRefinement.prompt.label' | localize"
    [placeholder]="'Common.dialog.aiRefinement.prompt.placeholder'"
    tooltip="Common.dialog.aiRefinement.prompt.tooltip"
    [iconClickable]="true"
    [iconClickableTooltip]="'Common.dialog.aiRefinement.prompt.refine'"
    [iconClickableDisabledTooltip]="'Common.dialog.aiRefinement.prompt.needValue'"
    [ariaHasPopup]="'dialog'"
    [(ngModel)]="prompt"
    [icon]="'fa-regular fa-arrow-right'"
    (focus)="clearSelectedPrompt()"
    (iconClick)="submitRefinementPrompt()"
>
</agpr-text-input>
<agpr-form-message *ngIf="!prompt && tryToSubmit">
    {{ 'Common.dialog.aiRefinement.prompt.required' | localize }}
</agpr-form-message>
